/**
 * Initializes and returns paypal checkout client
 * @param {object} braintree braintree client
 * @returns btPaypal checkout client, null if there is no braintree client or `error` with the error details
 */
const initPaypalCheckoutClient = async (braintree) => {
  if (!braintree) {
    return null;
  }

  try {
    const paypalCheckout = await (() =>
      import(/* WebpackChunkName: "swi-braintree-paypal" */ 'braintree-web/paypal-checkout'))();
    const btPaypal = paypalCheckout.create({client: braintree});

    return btPaypal;
  } catch (errorObject) {
    return {error: errorObject};
  }
};

/**
 * Returns the paypal client id.
 * If some error happens, the error is returned in the `error` field
 * @param {Object} btpaypal
 * @returns the PayPal client id to be used when loading the PayPal SDK
 */
const getPaypalClientId = async (btpaypal) => {
  if (!btpaypal) {
    return null;
  }

  try {
    const paypalClientId = await btpaypal.getClientId();

    return paypalClientId;
  } catch (errorObject) {
    return {error: errorObject};
  }
};

/**
 * Returns the paypal client id.
 * If some error happens, the error is returned in the `error` field
 * @param {Object} braintree
 * @returns the PayPal client id to be used when loading the PayPal SDK
 */
const getBraintreePaypalClientId = async (braintree) => {
  if (braintree) {
    const btpaypal = await initPaypalCheckoutClient(braintree);
    if (btpaypal && btpaypal.error) {
      return {error: btpaypal.error};
    } else if (btpaypal) {
      const paypalClientId = await getPaypalClientId(btpaypal);
      if (paypalClientId && paypalClientId.error) {
        return {error: paypalClientId.error};
      } else if (paypalClientId) {
        return paypalClientId;
      }
    }
  }
};

export {initPaypalCheckoutClient, getPaypalClientId, getBraintreePaypalClientId};
